import React, { Component } from 'react';
import { Alert } from 'react-bootstrap';
import Checkbox from './Checkbox';
import './Complaint.css';

const OPTIONS = [
    { typeID: 1, type: 'Sale to Minor', desc: 'This complaint should contain information regarding a person(s) under the age of 21 obtaining alcohol in a premises licensed to traffic alcoholic beverages. The complaint should contain a specific time and date this occurred, who served the minor and the regularity, for example “Every Thursday night” or “Every weekend” etc.' },
    { typeID: 2, type: 'Sale to Intoxicated Patron', desc: 'This complaint should contain information regarding the serving and/or selling of alcoholic beverages to a visibly intoxicated person(s) in a premises licensed to traffic alcoholic beverages. The complaint should contain a specific time and date this occurred, who served the person and the regularity, for example “Every Thursday night” or “Every weekend” etc. ' },
    { typeID: 3, type: 'Assault/Fight', desc: 'This complaint should contain information regarding a fight and/or an assault in relation to a premises licensed to traffic alcoholic beverages. The complaint should contain a specific date and time of the incident and who was involved.' },
    { typeID: 4, type: 'Noise', desc: 'This complaint should contain information regarding a noise disturbance, for example music, thumping bass, and/or patrons in relation to a premises licensed to traffic alcoholic beverages. The complaint should contain a specific date and time of the noise disturbance and the regularity, for example “Every Thursday night” or “Every weekend” etc. ' },
    { typeID: 5, type: 'Other', desc: 'These complaints may contain a variety of information, for example: Extension of premises- patrons consuming alcoholic beverages in unlicensed areas. Purchase from Unauthorized Source- the establishment obtaining alcohol from someone other than a NYS licensed wholesaler or manufacturer. Prohibited Hours- consumption and/or serving alcoholic beverages at an establishment before or after allowed hours. Availing of the license-someone taking ownership of an establishment other than the person or entity licensed by the NYS Liquor Authority. ' }
];

var typeArray = [];

export class ComplaintType extends Component {
    state = {
        checkboxes: OPTIONS.reduce(
            (options, option) => ({
                ...options,
                [option.type]: false
            }), null
        )

    };

    componentWillReceiveProps(props) {

        if (props.complaintTypeObj.length === 0 && typeArray.length > 0) {
            this.clearComplaintType();
        }
    }

    handleCheckboxChange = changeEvent => {
        const name = changeEvent.target.value;

        this.setState(prevState => ({
            checkboxes: {
                ...prevState.checkboxes,
                [name]: !prevState.checkboxes[name]
            }
        }))
        ;

        if (!this.state.checkboxes[name]) {
            typeArray.push(name);
        }
        else {
            typeArray = typeArray.filter(val => val !== name);
        }

        this.props.passSelectedTypes(typeArray);

        const selectedTypes = OPTIONS
            .filter(function (c) {
                return typeArray.indexOf(c.type) > -1;
            })
            .map(item => ({
                complainttypeid: item.typeID,
                complainttypename: item.type
            }));

        this.props.complaintTypeSelected(selectedTypes);
    }

    createCheckbox = (option) =>
        <Checkbox
            label={option.type}
            isSelected={this.state.checkboxes[option.type]}
            onCheckboxChange={this.handleCheckboxChange}
            key={option.type}
            desc={option.desc}
        />;


    createCheckboxes = () => OPTIONS.map(this.createCheckbox);

    clearComplaintType = () => {
        this.setState({
            checkboxes: OPTIONS.reduce(
                (options, option) => ({
                    ...options,
                    [option.type]: false
                }), null
            )
        });
        typeArray = [];
    }

    showValidationMessage = () => {
        if (this.props.validationMsg === '') return null;
        return <Alert ref="alertVisible" className="alert alert-danger" dismissible="true">{this.props.validationMsg} </Alert>;
    }

    render() {
        return (
            <div className="container">
                <div className="row mt-5">
                    <fieldset id="step1">
                        <legend><span className="fieldset-legend">Step 1 of 4 - Type(s) of Complaint</span></legend>
                        <div className="col-sm-12 fieldset-wrapper">
                            <h3>Please select all categories that apply to your complaint. <span className="mandatory">(required)</span></h3>
                            {this.showValidationMessage()}
                            <div className="checkbox-group required">
                                {this.createCheckboxes()}
                            </div>

                        </div>
                    </fieldset>
                </div>
            </div>
        );
    }
}

export default ComplaintType;



// WEBPACK FOOTER //
// ./src/components/ComplaintType.js